import Modal from "root/Modals/VanillaModal/VanillaModal";
import "root/Modals/VanillaModal/Modal.scss";

import $ from "jquery";

export { Globals, handleAxiosError, getCookie, setCookie, displayAlert } ;

import ErrorStackParser from 'error-stack-parser';
import {checkError, handleAjaxError} from "root/DataFunctions/ErrorHandlingFunctions";

export const ageBands = {
    AGE_BAND_24_MONTHS: 1,
    AGE_BAND_30_MONTHS: 2,
    AGE_BAND_36_MONTHS: 3,
    AGE_BAND_42_MONTHS: 4,
    AGE_BAND_48_MONTHS: 5,
    AGE_BAND_54_MONTHS: 6,
    AGE_BAND_60_MONTHS: 7,
}


const Globals = (function()
{
    const APIFolder = '/api/v1.0';

    function Globals() {
    }

    Object.defineProperty(Globals, "APIFolder", {
        get: function() {
            return 'https://' + document.location.hostname + APIFolder;
        },
    });

    Object.defineProperty(Globals, "School360APIFolder", {
        get: function() {
            return 'https://' + 'school360.pc' + APIFolder;
        },
    });

    Object.defineProperty(Globals, "BaseURL", {
        get: function() {
            return 'https://' + document.location.hostname ;
        },
    });

    return Globals;
})();

export const getDataWithPromise = (url, type, data, suppressErrorCheck )  =>
{
    return new Promise((resolve, reject) =>
    {
        if ( url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
        $.ajax(
            {
                type: type,
                url: url,
                data: data,
                success: (data) =>
                {
                    if ( suppressErrorCheck === true )
                    {
                        // Return a silent error if required
                        resolve ( data );
                    }
                    else if (checkError(data))
                    {
                        resolve ( data );
                    }
                },
                error: (jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                }
            });
        }
    });
}

export const getStatusFromResponse = ( response ) =>
{
    return response.status ;
}

export const getDataFromResponse = ( response ) =>
{
    return response.data ;
}

export const getNumRowsFromResponse = ( response ) =>
{
    return response.status.rowsAffected ;
}
// *********************************************
// DISPLAY ERRORS - IN PROGRESS
//*********************************************

function setCookie(cookieName, cookieValue, expiryDays)
{
    const d = new Date();
    d.setTime(d.getTime() + (expiryDays*24*60*60*1000));
    const expires = "expires=" + d.toGMTString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

function getCookie(cookieName)
{
    const name = cookieName + "=";

    const decodedCookie = decodeURIComponent(document.cookie);

    const ca = decodedCookie.split(';');

    for(let i = 0; i < ca.length; i++)
    {
        let c = ca[i];
        while (c.charAt(0) === ' ')
        {
            c = c.substring(1);
        }

        if (c.indexOf(name) === 0)
        {
            return c.substring(name.length, c.length);
        }
    }

    return "";
}

function displayAlert ( params )
{
    let title = 'Alert' ;
    let displayMessage = "EMPTY MESSAGE" ;

    if ( params.title != null )
    {
        title = params.title ;
    }

    if ( params.message != null )
    {
        displayMessage = params.message ;
    }

    const myModal = new Modal({
        title: title,
        width: '400px',
        headerBackgroundColor: params.headerBackgroundColor,
        headerTextColor: params.headerTextColor,
        content: displayMessage
    }).show();

}

const handleAxiosError = (error, returnUrl) =>
{
    console.log(error);

    const stackFrames = getThisErrorObject() ;

    const callingFrame = stackFrames[2] ;

    let fullMessage = error.message +
        '<p>In ' + callingFrame.functionName + ' in ' + callingFrame.fileName + ' Line number ' + callingFrame.lineNumber +  '</p>' +
        'Attempting to call ' + error.request.responseURL + '</p>';

    if ( error.response != null )
    {
        if ( error.response.data != null )
        {
            if ( error.response.data.errorType == 'exception')
            {
                fullMessage += "<p>API Error in " + error.response.data.errorDetail.file + " at line " + error.response.data.errorDetail.line + '<p>' ;
                fullMessage += '<p>' + error.response.data.errorDetail.message + '<p>' ;
            }
        }
    }

    const myModal = new Modal({
        title: 'The operation failed',
        width: '500px',
        content: fullMessage
    }).show();
}

const  getThisErrorObject = () =>
{
    try
    {
        throw Error('')
    }
    catch(err)
    {
        const res = ErrorStackParser.parse(err);

        return res;
    }
}

/*

(function($) {
    $.retryAjax = function (ajaxParams) {
        var errorCallback;
        ajaxParams.tryCount = (!ajaxParams.tryCount) ? 0 : ajaxParams.tryCount;
        ajaxParams.retryLimit = (!ajaxParams.retryLimit) ? 2 : ajaxParams.retryLimit;
        ajaxParams.suppressErrors = true;

        if (ajaxParams.error) {
            errorCallback = ajaxParams.error;
            delete ajaxParams.error;
        } else {
            errorCallback = function () {

            };
        }

        ajaxParams.complete = function (jqXHR, textStatus) {
            if ($.inArray(textStatus, ['timeout', 'abort', 'error']) > -1) {
                this.tryCount++;
                if (this.tryCount <= this.retryLimit) {

                    // fire error handling on the last try
                    if (this.tryCount === this.retryLimit) {
                        this.error = errorCallback;
                        delete this.suppressErrors;
                    }

                    //try again
                    $.ajax(this);
                    return true;
                }

                window.alert('There was a server error.  Please refresh the page.  If the issue persists, give us a call. Thanks!');
                return true;
            }
        };

        $.ajax(ajaxParams);
    };
}(jQuery));

(function($) {

    $.originalAjax = $.ajax ;

    $.ajax = function (ajaxParams) {

        ajaxParams.loggingIn = false;

        let oldError = ajaxParams.error;

        ajaxParams.error = function (jqXHR, textStatus, error)
        {
            if ( errorOccurredBecauseAuthenticationRequired( this, jqXHR, textStatus, error ) )
            {
                // if we're handling an authentication error, it probably means the user has a session timeout
                // so we need to ask them to re-authenticate
                //
                // Once the user has logged in again, we can continue the request using the original parameters

                ajaxParams.loggingIn = true ;

                tryAgain ( this, textStatus, jqXHR );
            }
            else
            {
                // Just pass the result on to the original Success handler
                if ( oldError != null )
                {
                    oldError(jqXHR, textStatus, error);
                }
            }
        };

        $.originalAjax(ajaxParams);
    };
}(jQuery));

*/
function errorOccurredBecauseAuthenticationRequired ( response, jqXHR, textStatus, error )
{
    let res = false ;

    if ( response.loggingIn == true )
    {
        // This is a successful route
        res = false ;
    }
    else
    {
        let data = jqXHR.responseJSON ;

        if ( data != null && data.result != null && data.result == "fail" && data.error != null && ( data.error == "Authentication Fail" || data.error == 'authenticationException') )
        {
            res = true ;
        }
    }

    return res ;
}

function functionFailedBecauseAuthenticationRequired ( response, data )
{
    let res = false ;

    if ( response.loggingIn == true )
    {
        // This is a successful route
        res = false ;
    }
    else
    {
        if ( data != null && data.result != null && data.result == "fail" && data.error != null && data.error == "Authentication Fail" )
        {
            res = true ;
        }
    }

    return res ;
}

function doLogin( response, textStatus, jqXHR, username, password, establishment )
{
    // Globals are defined in the globals.js class
    var root = Globals.APIFolder ;

    var service = "/login" ;

    $.ajax({
        type: 'POST',
        url: root + service,
        data: { inpUsername: username, inpPassword: password, inpEstablishmentNumber: establishment  },
        success:(data)=>
        {
            if ( data.status.result == 'success')
            {
                $.originalAjax ( response ) ;
            }
            else
            {
                tryAgain ( response, textStatus, jqXHR) ;
            }
        },
        error:(jqXHR, textStatus, error)=>
        {
            handleAjaxError ( jqXHR, textStatus, error) ;
        }
    });
}

function loginFormElements ()
{
    var string = "<div>" ;

    string+= '<h2>Session Timed Out</h2>' ;

    string+= '<p>Your session has timed out.</p>' ;

    string+= '<p>Please re-enter your login credentials to continue</p>' ;

    string += "<form class='form' role='form'>" ;
    string += '<div class="form-group">' ;
    string += '<label for="inputEstablishment">Establishment Number</label>' ;
    string += '<input type="text" class="form-control" id="inputEstablishment" name="inputEstablishment" placeholder="Establishment NUmber">' ;
    string += '</div> ' ;
    string += '<div class="form-group">' ;
    string += '<label for="inputUserName">User Name</label>' ;
    string += '<input type="text" class="form-control" id="inputUserName" name="inputUserName" placeholder="User Name">' ;
    string += '</div> ' ;
    string += '<div class="form-group"> ';
    string += '<label for="inputPassword">Password</label>' ;
    string += '<input type="password" class="form-control" id="inputPassword" name="inputPassword" placeholder="Password"> ' ;
    string += '</div>';
    string += "</form>" ;
    string += "<div>" ;

    return string ;
}

function tryAgain ( response, textStatus, jqXHR)
{
    var form = loginFormElements () ;

    var modal = bootbox.dialog({
        message: form,
        title: "",
        buttons: [
            {
                label: "Login",
                className: "btn btn-primary pull-right",
                callback: function() {

                    var inputUserName = $('div.bootbox-body form.form div.form-group input#inputUserName');
                    var userName = inputUserName[0].value;

                    var inputUserPassword = $('div.bootbox-body form.form div.form-group input#inputPassword');
                    var userPassword = inputUserPassword[0].value;

                    var inputEstablishment = $('div.bootbox-body form.form div.form-group input#inputEstablishment');
                    var establishment = inputEstablishment[0].value;

                    doLogin ( response, textStatus, jqXHR, userName, userPassword, establishment) ;

                    return true;
                }
            }
        ],
        show: false,
        onEscape: function() {
            modal.modal("hide");
        }
    });

    modal.modal("show");
}
